import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import UpdateFlowStep from './UpdateFlowStep'

class DatesStep extends UpdateFlowStep {
  constructor(component: ReactNode) {
    super(i18n.t('contract_versions.flows.update.steps.dates.request_title'), component)
  }
}

export default DatesStep
